import { NetworkStatus } from '@cbridge-utils/network';
import { IDictSymbolState } from './dictSymbol.interface';

export const initialState: IDictSymbolState = {
  list: [],
  networkStatus: NetworkStatus.Started,
};
